import { ClipboardCheck, FileText, Key, Search, Truck } from "lucide-react";
import ownHomeImg from "shared/assets/inspiration/ins-001-own-home.jpg";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { InspirationTimelineStep } from "web_myplann/Inspiration/Components/InspirationTimeline";
import type { SliderBounds } from "web_myplann/Inspiration/Types/SliderBounds";
import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";

export const OWN_HOME_IMAGE = ownHomeImg;

export const OWN_HOME_GOAL_CATEGORY = GoalCategoryTypeEnum.House;

export const OWN_HOME_HORIZON_YEARS = 30;
export const OWN_HOME_MORTGAGE_MONTHS = OWN_HOME_HORIZON_YEARS * MONTHS_IN_YEAR;
export const OWN_HOME_LTV_PERCENT = 80;
export const OWN_HOME_MORTGAGE_LTV = OWN_HOME_LTV_PERCENT / 100;

export const OWN_HOME_RENT_FIELD: SliderBounds = {
	min: 3_000,
	max: 60_000,
	step: 500,
	softMin: 5_000,
	softMax: 35_000,
};
export const OWN_HOME_RENT_FALLBACK = 18_000;

export const OWN_HOME_INCOME_FIELD: SliderBounds = {
	min: 10_000,
	max: 300_000,
	step: 1_000,
	softMin: 20_000,
	softMax: 200_000,
};
export const OWN_HOME_INCOME_FALLBACK = 55_000;

export const OWN_HOME_SAVINGS_FIELD: SliderBounds = {
	min: 0,
	max: 2_000_000,
	step: 10_000,
	softMax: 3_000_000,
};
export const OWN_HOME_SAVINGS_FALLBACK = 0;

export const OWN_HOME_DOWN_PAYMENT_SAVING = 8_000;

export const OWN_HOME_EXPENSES_FIELD: SliderBounds = {
	min: 3_000,
	max: 200_000,
	step: 1_000,
	softMin: 15_000,
	softMax: 150_000,
};
export const OWN_HOME_EXPENSES_FALLBACK = 35_000;

const TimelineResources = Resources.Inspiration.OwnHome.Result.Timeline;

export const OWN_HOME_TIMELINE_STEPS: InspirationTimelineStep[] = [
	{ icon: FileText, step: TimelineResources.prep },
	{ icon: Search, step: TimelineResources.search },
	{ icon: ClipboardCheck, step: TimelineResources.mortgage },
	{ icon: Key, step: TimelineResources.approval },
	{ icon: Truck, step: TimelineResources.moving },
];
